import React from 'react';
import Button from './ui/Button';
import Dialog from './ui/Dialog';

interface Props {
  open: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const ConfirmActionModal: React.FC<Props> = ({
  open,
  title = 'Confirme a ação',
  message = 'Tem certeza que deseja executar esta ação?',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  // Aprovação confirma em verde; qualquer outra ação (reprovar, devolver, excluir) em vermelho.
  const isApprove = /aprovar|aprovação/i.test(confirmLabel || title || '');

  return (
    <Dialog
      open={open}
      title={title}
      align="start"
      onClose={onCancel}
      actions={(
        <>
          <Button variant="secondary" onClick={onCancel}>{cancelLabel}</Button>
          <Button variant={isApprove ? 'success' : 'danger'} onClick={onConfirm} loading={loading}>
            {loading ? 'Processando...' : confirmLabel}
          </Button>
        </>
      )}
    >
      <p>{message}</p>
    </Dialog>
  );
};

export default ConfirmActionModal;
